import React from "react";
import borderRightImg from "../../assets/images/webp/other/border-right.webp";
import { SPEAKER_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";

const SpeakerInvitation = () => {
  return (
    <>
      <div className="bg-center bg-cover bg-no-repeat bg-speaker-bg">
        <div className="container w-full mx-auto xl:py-[152px] lg:py-32 md:py-24 py-10">
          <div className="w-full max-w-[545px]">
            <BlueTag variant="white">Speaker Invitation</BlueTag>
            <h2 className="text-white text-[60px] font-bold leading-[120%] ff-jakarta max-lg:text-5xl max-md:text-4xl max-sm:text-3xl">
              Now a Celebrated Speaker
            </h2>
            <p className="text-[#D7D7D7] text-base font-medium leading-[150%] pt-4 ff-jakarta">
              From dusty village roads to bright seminar stages, Deepak Sharma
              now inspires thousands through his raw, real, and deeply
              motivating story.
            </p>
            <div className="flex items-center gap-2 pt-4">
              <Icons icon="WhiteCheckIcon" />
              <p className="text-white text-sm font-medium leading-[19.31px]">
                If I can rise from nothing to everything – so can you.
              </p>
            </div>
            <div className="flex items-center gap-[22px] flex-wrap max-lg:gap-4 pt-10">
              {SPEAKER_LIST.map((obj, i) => (
                <div key={i} className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <Icons icon={obj.icon} />
                    <h4 className="text-[#FAFAFA] font-medium text-2xl leading-[145%] ff-helvetica">
                      {obj.name}
                    </h4>
                  </div>
                  {i !== SPEAKER_LIST.length - 1 && (
                    <img
                      src={borderRightImg}
                      width={4}
                      height={27}
                      alt="line"
                      className="h-[27px]"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SpeakerInvitation;
